module.exports = __webpack_public_path__ + "static/media/video_audio.c726099e.mp4";